module.exports = __webpack_public_path__ + "1f5d0ad16dd0f30e0a2aa16dcb3cecd9.svg";